import { ToastNotice } from '@elladx/design-system';
import { useLayoutEffect, useRef } from 'react';
import type { Toast as ToastType } from '../types';
interface ToastProps {
    toast: ToastType;
    onClose: (id: string) => void;
}
function Toast({ toast, onClose }: ToastProps) {
    return <ToastNotice tone={toast.type} title={toast.title} message={toast.message} onClose={() => onClose(toast.id)}/>;
}
export function ToastContainer({ toasts, onClose }: {
    toasts: ToastType[];
    onClose: (id: string) => void;
}) {
    const containerRef = useRef<HTMLDivElement>(null);
    const announcedIdsRef = useRef(new Set<string>());
    const latestId = toasts[toasts.length - 1]?.id;
    useLayoutEffect(() => {
        if (!latestId || announcedIdsRef.current.has(latestId))
            return;
        announcedIdsRef.current.add(latestId);
        if (!window.matchMedia('(max-width: 767px)').matches || document.querySelector('dialog[open]'))
            return;
        const notice = containerRef.current?.lastElementChild;
        if (!notice)
            return;
        // Feedback stays in the phone's page flow. Make new feedback reachable
        // when its action was below the fold, without revisiting expired notices.
        const bounds = notice.getBoundingClientRect();
        if (bounds.top < 0 || bounds.bottom > window.innerHeight)
            notice.scrollIntoView({ block: 'nearest' });
    }, [latestId]);
    if (!toasts.length)
        return null;
    return <div ref={containerRef} className="toast-container" aria-live="polite" aria-label="Notifications">{toasts.map(toast => <Toast key={toast.id} toast={toast} onClose={onClose}/>)}</div>;
}
export default Toast;
